import { Injectable } from '@angular/core'

const APP_PREFIX = 'TCD_v2'

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  loadInitialState() {
    if (localStorage.length < 1) {
      return undefined
    }

    return Object.keys(localStorage).reduce((state, storageKey) => {
      if (storageKey.includes(APP_PREFIX)) {
        const currentStateRef = state
        // stateKeys.forEach((key, index) => {
        //   if (index === stateKeys.length - 1) {
        //     currentStateRef[key] = JSON.parse(localStorage.getItem(storageKey));
        //     return;
        //   }
        //   currentStateRef[key] = currentStateRef[key] || {};
        //   currentStateRef = currentStateRef[key];
        // });
      }
      return state
    }, {})
  }

  setItem(value: unknown) {
    localStorage.setItem(`${APP_PREFIX}`, JSON.stringify(value))
  }

  getItem(): unknown | null {
    const item = localStorage.getItem(`${APP_PREFIX}`)
    return item ? JSON.parse(item) : null
  }

  removeItem() {
    localStorage.removeItem(`${APP_PREFIX}`)
  }
}
